import { ITeamsModel } from '@models/Competition';
import { IUserInfoModel } from '@models/User';
import { IAuthCredentials, IAuthModel, ISession } from '@models/AuthUser';
import { IAPIResponse, AbstractAPI, EnumAPIStatus, IAPIPaginationResponse } from '@api/AbstractAPI';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable, filter } from 'rxjs';
import { IFilterClassification, IFilterList, IFilterPublicAssetsList } from '@models/Content';
import { IDashboardResult } from '@models/Dashboard';

@Injectable({
    providedIn: 'root'
})
export class WebService extends AbstractAPI {

    public serverSessionLossSubject: Subject<boolean>;

    public ServerSessionLoss: Observable<boolean>;

    constructor(protected HttpClient: HttpClient) {
        super(HttpClient);

        this.serverSessionLossSubject = new Subject<boolean>();

        this.ServerSessionLoss = this.serverSessionLossSubject.asObservable();
    }

    //#region AUTHENTICATION METHODS

    /**
     * 
     * @param data 
     * @returns 
     */
    async Login(data: IAuthCredentials): Promise<IAPIResponse<IAuthModel>> {

        // nop futuro para multiplos projetos será necessario passar a global de modo a identificar o utilizador para o projeto
        const submit =
        {
            // global: this.Global,
            // data: {
            username: data.Username,
            password: data.Password
            // }
        };

        try { return await this.RequestPOST<IAuthModel>("Auth/Login", submit); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async RecoverPassword(data: any): Promise<IAPIResponse<IUserInfoModel>> {

        try { return this.handleAuthResponse(await this.RequestPOST<IUserInfoModel>("Auth/RecoverPassword", data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ResetPassword(data: any): Promise<IAPIResponse<IUserInfoModel>> {

        try { return this.handleAuthResponse(await this.RequestPOST<IUserInfoModel>("Auth/ResetPassword", data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ChangePersonalData(data: any): Promise<IAPIResponse<IUserInfoModel>> {

        try { return this.handleAuthResponse(await this.RequestPOST<IUserInfoModel>("Auth/ChangeName", data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ChangePassword(data: any): Promise<IAPIResponse<IUserInfoModel>> {

        try { return this.handleAuthResponse(await this.RequestPOST<IUserInfoModel>("Auth/ChangePassword", data)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @returns 
     */
    async Logout(): Promise<IAPIResponse<boolean>> {

        try { return this.handleAuthResponse(await this.RequestGET<boolean>("Auth/Logout")); }
        catch (error) { return error; }
    }

    //#endregion


    //#region GENERIC METHODS

    /**
     * 
     * @param formData 
     * @returns 
     */
    async UploadAndGetUrl(formData?: FormData): Promise<IAPIResponse<string>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<string>("Generic/File/UploadAndGetUrl", formData)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetGenreList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Generic/Gender/List`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCalendarYear 
     * @returns 
     */
    async GetDashboardData(idCalendarYear?: string): Promise<IAPIResponse<IDashboardResult>> {

        // ?idCalendarYear=${idCalendarYear}
        try { return this.handleAuthResponse(await this.RequestGET<IDashboardResult>(`Dashboard`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param startDate
     * @param endDate 
     * @returns 
     */
    async GetDashboardStatistics(startDate: string = "", endDate: string = ""): Promise<IAPIResponse<any>> {

        const params = {
            StartDate: startDate,
            EndDate: endDate
        };

        try { return this.handleAuthResponse(await this.RequestPOST<IDashboardResult>(`Dashboard/Statistics`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @returns 
     */
    async GetPlatformList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Generic/PlatformList`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetAvailableLanguages(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Generic/Language/List`)); }
        catch (error) { return error; }
    }

    /**
    * 
    * @param searchText 
    * @param idContinent 
    * @returns 
    */
    async GetCountryList(searchText: string, idContinent: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Generic/Country/List?searchText=${(searchText || '')}&idContinent=${(idContinent || '')}`)); }
        catch (error) { return error; }
    }


    //#endregion

    //#region COMMMON

    async GetEntity(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Common/Entity?id=${id}`)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @returns 
     */
    async GetEntityList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Common/Entity/List`)); }
        catch (error) { return error; }
    }



    /**
     * 
     * @param idCampaign 
     * @param filters 
     * @returns 
     */
    async GetBlackListItemList(idCampaign, filters: any): Promise<IAPIResponse<any>> {

        const params = {};

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/BlackListItem/List?idCampaign=${idCampaign}`, params)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @returns 
     */
    async GetOCRConfiguration(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Common/Entity/Configuration/OCR`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetEntityConfiguration(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Common/Entity/Configuration/List`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveOCRConfiguration(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/Configuration/OCR/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveOCRItemsConfiguration(data: any[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/BlackListItem/List/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async DeleteOCRItemsConfiguration(data: string[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/BlackListItem/List/Delete`, data)); }
        catch (error) { return error; }
    }

    /**
    * 
    * @param data 
    * @returns 
    */
    async GetMerchantConsumptionsListAccepted(data): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/Consumption/Accepted`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async GetMerchantConsumptionsListRejected(data): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/Consumption/Internal/Rejected`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async GetMerchantConsumptionsListPSWRejected(data): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Common/Entity/Consumption/PSW/Rejected`, data)); }
        catch (error) { return error; }
    }

    //#endregion

    //#region MENUS

    /**
     * devolve a lista de menus que o utilizador tem acesso
     * @returns 
     */
    async GetNavigationList(): Promise<IAPIResponse<any[]>> {

        try { return this.handleAuthResponse(await this.RequestGET<any[]>("Menu/NavigationList")); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idParent 
     * @param idModule 
     * @returns 
     */
    async GetSimpleMenuListPermissions(idParent?: string, idModule?: number): Promise<IAPIResponse<any>> {

        const params: string = `idParent=${idParent || ''}&idModule=${idModule || ''}&isPublic=${''}&isTabNavigation=${''}`;

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Menu/SimpleList?${params}`)); }
        catch (error) { return error; }
    }

    /**
     * Devolve todas as permissoes criadas
     * @returns 
     */
    async GetMenuListModules(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>("Menu/ModuleList")); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idModule 
     * @param idMenu 
     * @returns 
     */
    async GetOperationList(idModule?: string, idMenu?: string): Promise<IAPIResponse<any>> {

        // const params = `idModule=${idModule}&idMenu=${idMenu}`;

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Menu/OperationList?idModule=${idModule || ''}&idMenu=${idMenu || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetMenuTabList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>("Menu/TabList")); }
        catch (error) { return error; }
    }
    /**
     * devolve lista de menus de todo projeto para configuração
     * @returns 
     */
    async GetMenuList(idPlatform?: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Menu/List?idPlatform=${idPlatform || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * devolve menu para configuração
     * @returns 
     */
    async GetMenu(id: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Menu/${id || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveMenu(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Menu/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async DeleteMenu(id: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Menu/Delete?id=${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param menus 
     * @returns 
     */
    async ChangePositionMenu(menus: { Id: string, Position: number, IdParent?: string }[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Menu/ChangePosition`, menus)); }
        catch (error) { return error; }
    }

    //#endregion

    //#region CONTENT METHODS
    /**
     * @param filters
     * @returns 
     */
    async GetContentList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {


        const params = `PageNumber=${filters?.PageNumber || ''}
        &PageRows=${filters?.PageRows || ''}
        &Text=${filters.Text || ''}`;

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Content/List?${params}`)); }
        catch (error) { return error; }
    }

    /**
     * @param id
     * @returns 
     */
    async DeleteContentItem(id: number): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Content/Delete/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetContentDetails(id: number, idEdition: number = 0): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Content/${id}?idEdition=${idEdition || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * @param data
     * @returns 
     */
    async SaveContentData(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Content/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetContentTypeList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Content/Type/List`)); }
        catch (error) { return error; }
    }

    //#endregion

    //#region NOTIFICATIONS

    /**
     * @param filters
     * @returns 
     */
    async GetNotificationList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            WasViewed: filters?.WasViewed ?? '',
            SearchData: {
                PageNumber: filters?.PageNumber || '',
                PageRows: filters?.PageRows || '',
                Text: filters?.Text || '',
                OrderDescending: filters?.OrderDescending ?? '',
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Notification/List`, params)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param id 
     * @returns 
     */
    async GetDetail(id): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Notification/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async MarkAsUnreadedNotification(id): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Notification/Unread/Set/${id}`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @returns 
     */
    async GetNotificationsCounter(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Notification/User/UnreadCounter`)); }
        catch (error) { return error; }
    }

    //#endregion

    //#region USERS

    /**
     * 
     * @returns 
     */
    async GetUserInfo(): Promise<IAPIResponse<IUserInfoModel>> {

        try { return this.handleAuthResponse(await this.RequestGET<IUserInfoModel>("User/Info")); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetUsersList(filters: IFilterList): Promise<IAPIResponse<any[]>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any[]>(`User/List?PageNumber=${filters?.PageNumber || ''}&PageRows=${filters?.PageRows || ''}&Text=${filters.Text || ''}&OrderDescending=${filters.OrderDescending ?? ''}&IdRole=${filters.IdRole ?? ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetUsersById(id: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any[]>(`User/${id || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data
     * @returns 
     */
    async SaveUser(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any[]>(`User/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data
     * @returns 
     */
    async DeleteUser(data: { idUser?: string, detailsList: { description: string }[] }): Promise<IAPIResponse<any[]>> {

        const params = data;

        try { return this.handleAuthResponse(await this.RequestPOST<boolean>("User/CancelAccount", params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idWallet 
     * @param idWalletCard 
     * @returns 
     */
    async CancelUserCard(idWallet: string, idWalletCard: string): Promise<IAPIResponse<any[]>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any[]>(`Wallet/CancelCard?idWallet=${idWallet || ''}&idWalletCard=${idWalletCard || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetRoleUsersList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`User/Role/List`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetRoleUserPermissionTemplate(id: string = null): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`User/Permissions/Template?id=${id || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idUserRole 
     * @returns 
     */
    async GetRoleUserPermissionListTemplate(idUserRole: number = null): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`User/Permissions/TemplateList?idUserRole=${idUserRole || ''}`)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveRoleUserPermissionTemplate(data: any): Promise<IAPIResponse<any>> {

        const params = data;

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Permissions/SaveTemplate`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async DeleteRoleUserPermissionTemplate(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Permissions/DeleteTemplate?id=${id || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async UserGenerateNewPassword(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Credentials/GenerateNewPassword/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async UserSendEmailToDefinePassword(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Credentials/SendEmailToDefinePassword/${id}`)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param id 
     * @returns 
     */
    async UserConsumerDelete(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Consumer/Delete?id=${id}`)); }
        catch (error) { return error; }
    }


    /**
     * historico de alteraçoes no perfil do consumidor
     * @param id 
     * @param filters 
     * @returns 
     */
    async UserEventList(id: string, filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params =
        {
            IdUser: id || '',
            SearchData:
            {
                PageNumber: filters?.PageNumber || '',
                PageRows: filters?.PageRows || '',
                Text: filters?.Text || '',
                OrderDescending: filters?.OrderDescending ?? '',
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Event/List`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param id 
     * @returns 
     */
    async GetUserHouseHolderMembers(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`User/HouseHold/GetMemberList?iduser=${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param text 
     * @param idMerchant 
     * @returns 
     */
    async SearchConsumerByMerchant(text: string, idMerchant: string): Promise<IAPIResponse<any>> {

        const params =
        {
            textSearch: text,
            idMerchant: idMerchant,
            idModule: null,
            idRole: null,
            dateRef: null
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Merchant/Campaign/Search`, params)); }
        catch (error) { return error; }
    }
    //#endregion

    //#region REPORTS


    //#endregion

    //#region CAMPAIGN

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetCampaign(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign?id=${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idEntity 
     * @returns 
     */
    async GetCampaignList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params =
        {
            idModuleList: filters?.IdList || filters?.IdModule || '',
            SearchData:
            {
                PageNumber: filters?.PageNumber || '',
                PageRows: filters?.PageRows || '',
                Text: filters?.Text || '',
                OrderDescending: filters?.OrderDescending ?? '',
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveCampaign(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @param idCampaign 
     * @returns 
     */
    async SaveCampaignDraftConfiguration(data: any[], idCampaign: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Draft/SaveList?idCampaign=${idCampaign}`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async DeleteCampaign(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Delete?id=${id}`)); }
        catch (error) { return error; }
    }

    async SaveCampaignFiles(idCampaign: string, data: any[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/File/SaveList?idCampaign=${idCampaign}`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaign 
     * @param idCampaignFileList 
     * @returns 
     */
    async DeleteCampaignFiles(idCampaign: string, idCampaignFileList: string[]): Promise<IAPIResponse<any>> {

        const params =
        {
            idCampaign: idCampaign,
            idCampaignFileList: idCampaignFileList || []
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/File/Delete/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaign 
     * @param filters
     * @returns 
     */
    async GetCampaignChargingList(idCampaign: string = '', filters: any): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/CampaignChargingList?idCampaign=${idCampaign || ''}`, filters)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    async GetCampaignChargingDetails(idCampaignCharging: string = ''): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign/CampaignChargingDetails/${idCampaignCharging || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaignCharging 
     * @param filters 
     * @returns 
     */
    async GetCampaignChargingUserList(idCampaignCharging: string = '', filters: any): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/CampaignChargingUserList/${idCampaignCharging || ''}`, filters)); }
        catch (error) { return error; }
    }

    /**
     * Guardar carregamento
     * @param data 
     * @returns 
     */
    async SaveCampaignCharging(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/SaveCampaignCharging`, data)); }
        catch (error) { return error; }
    }

    /**
     * Guardar carteiras para um carregamento
     * @param data 
     * @returns 
     */
    async SaveCampaignChargingWallet(data: any, idCampaignCharging: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/SaveCampaignChargingWallet/${idCampaignCharging}`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetAgreementCategory(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign/AgreementCategory?id=${id || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveAgreementCategory(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/AgreementCategory/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetAgreementCategoryList(filters?): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign/AgreementCategory/List`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async AgreementCategoryForcingListFirstSync(data: string[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/AgreementCategory/ForcingListSync`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param categoryId 
     * @returns 
     */
    async SyncCategoryWithMerchants(categoryId: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Category/Merchant/PSW/Update?categoryId=${categoryId}`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    async GenerateCampaignChargingFile(idCampaignCharging: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Payshop/CampaignChargingFile/Save?idCampaignCharging=${idCampaignCharging}`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    async DeleteCampaignCharging(idCampaignCharging: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/CampaignCharging/Delete/${idCampaignCharging}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    async SubmitCampaignCharging(idCampaignCharging: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/SubmitCampaignCharging/${idCampaignCharging}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    async SendPayshopCampaignChargingFile(idCampaignCharging: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Payshop/CampaignChargingFile/UploadPayshop?idCampaignCharging=${idCampaignCharging}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaignCharging 
     * @returns 
     */
    DownloadCampaignChargingFile(idCampaignCharging: string): Observable<any> {

        try { return this.RequestPOSTDownloadFile(`Campaign/ChargingFile/Download/${idCampaignCharging}`); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCategory 
     * @returns 
     */
    GetMerchantListAssociated(idCategory: string): Promise<IAPIResponse<any>> {

        try { return this.RequestGET(`Campaign/AgreementCategory/Merchant/List?idCategory=${idCategory}`); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    SaveMerchantListAssociated(data: any): Promise<IAPIResponse<any>> {

        try { return this.RequestPOST(`Campaign/MerchantEligible/List/Save`, data); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    DeleteMerchantListAssociated(data: any): Promise<IAPIResponse<any>> {

        try { return this.RequestPOST(`Campaign/MerchantEligible/List/Delete`, data); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    GetCampaignInvoiceBenefit(id: string): Promise<IAPIResponse<any>> {

        try { return this.RequestGET(`Campaign/InvoiceBenefit/${id}`); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    SaveCampaignInvoiceBenefit(data: any): Promise<IAPIResponse<any>> {

        try { return this.RequestPOST(`Campaign/InvoiceBenefit/Save`, data); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idModule 
     * @returns 
     */
    CampaignInvoiceBenefitList(idModule: number): Promise<IAPIResponse<any>> {

        try { return this.RequestGET(`Campaign/InvoiceBenefit/List${idModule ? '?idModule=' + idModule : ''}`); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param data 
     * @returns 
     */
    async CampaignConfigureUserModule(data: { IdUser: string, ModuleList: any[] }): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Card/User/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async CampaignCommitmentList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            searchData: {
                pageNumber: filters.PageNumber || 1,
                pageRows: filters.PageRows || 25,
                orderDescending: filters.OrderDescending ?? true,
                // "orderingField": 0,
                text: filters.Text || "",
                // "type": "",
                // "startDate": "",
                // "endDate": "",
            },
            idModule: filters?.IdModule || null
        };


        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Commitment/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id
     */
    async CampaignCommitmentById(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign/Commitment/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     */
    async CampaignCommitmentTypeList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Campaign/Commitment/Type/List`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data
     */
    async CampaignCommitmentSave(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Campaign/Commitment/Save`, data)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param id 
     * @returns 
     */
    async GetVoucher(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Vouchers/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @param idCampaign 
     * @returns 
     */
    async GetVoucherChargingList(idCampaign: string, filters): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Vouchers/ChargingList/${idCampaign ? ('?idCampaign=' + idCampaign) : ''}`, filters)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @param filters 
     * @param idDraftMoment
     * @param wasAwarded
     * @returns 
     */
    async GetDraftTicketList(id: string, filters: IFilterList, idDraftMoment: string = "", wasAwarded: boolean = false): Promise<IAPIPaginationResponse<any>> {

        const queryParams = `idDraft=${id || ''}&idDraftMoment=${idDraftMoment || ''}&idAssignMode=&wasAwarded=${wasAwarded || ''}`;

        const params = {
            pageNumber: filters?.PageNumber || '',
            pageRows: filters?.PageRows || '',
            OrderDescending: filters?.OrderDescending,
            text: filters?.Text || ""
        };
        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Draft/Ticket/List?${queryParams}`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param idCampaigns 
     * @returns 
     */
    async CampaignStatistics(idCampaigns: string[] = []): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Statistics`, idCampaigns)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idCampaign 
     * @returns 
     */
    async CampaignDraftsById(idCampaign: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Draft/GetByCampaign?idCampaign=${idCampaign}`)); }
        catch (error) { return error; }


    }

    /**
     * 
     * @param idDraftMoment 
     * @param awardQuantity
     * @returns     
     */
    async CampaignProcessDraftById(idDraftMoment: string, awardQuantity?: number): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Draft/ProcessDraft/${idDraftMoment}?awardQuantity=${awardQuantity || ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param formdata 
     * @returns 
     */
    async CampaignDraftClaimAward(formdata: FormData): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Draft/ClaimAward`, formdata)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async CampaignDraftCancelClaimAward(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Draft/Ticket/CancelAward`, data)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param data 
     * @returns 
     */
    async DuplicateCampaign(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/Duplicate`, data)); }
        catch (error) { return error; }
    }
    //#endregion


    //#region MERCHANTS

    /**
     * 
     * @param idMerchant 
     * @returns 
     */
    async GetMerchantCampaignList(idMerchant: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/Campaign/List/${idMerchant}`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param id 
     * @returns 
     */
    async GetMerchant(id: string, idVersion?: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/${id}${idVersion ? '?idMerchantVersion=' + idVersion : ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetMerchantList(filters: IFilterList, status: number[] = []): Promise<IAPIPaginationResponse<any>> {

        const params = {
            searchData: {
                pageNumber: filters.PageNumber || 1,
                pageRows: filters.PageRows || 25,
                orderDescending: filters.OrderDescending ?? true,
                // "orderingField": 0,
                text: filters.Text || "",
                // "type": "",
                // "startDate": "",
                // "endDate": "",
            },
            statusList: status,
            idEconomicActivityCodeCategory: "", // mcc
            economicActivityCodeList: [], // cae child
            economicActivityCodeCategoryIdList: filters?.Categories || [], // cae parent
            idModule: filters?.IdModule || null
        };

        // ?${params}
        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/ResumeStatusList`, params)); }
        catch (error) { return error; }
    }

    /**
     * guardar dados do comerciante
     * @param data 
     * @returns 
     */
    async SaveMerchant(data: FormData): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Merchant/Save`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async DeleteMerchant(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Delete?id=${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idMerchant 
     * @param data 
     * @param idVersion
     * @returns 
     */
    async SaveMerchantFiles(idMerchant: string, data: any[], idVersion: string = ''): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/File/SaveList?idMerchant=${idMerchant}&idVersion=${idVersion}`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idFile 
     * @returns 
     */
    async DeleteMerchantFile(idFile: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/File/Delete`, JSON.stringify(idFile))); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param file 
     * @returns 
     */
    async MerchantFileDefineMain(file: { idMerchant: string, idMerchantFile: string, isMain: boolean }): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/File/DefineMain`, file)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param includeAlreadyConnectedUsers 
     * @param idCurrentMerchant 
     * @returns 
     */
    async SearchUserListManager(text?: string, includeAlreadyConnectedUsers?: boolean, idCurrentMerchant?: string): Promise<IAPIResponse<any>> {

        const params = `
			text=${text || ''}
			&includeAlreadyConnectedUsers=${includeAlreadyConnectedUsers ?? false}
			&idCurrentMerchant=${idCurrentMerchant || ''}
		`;

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/Manager/SearchUserList?${params}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async SaveListManager(data: { IdMerchant: string, UserList: any[] }): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Manager/SaveList`, data)); }
        catch (error) { return error; }
    }

    /**
     * Importar lista de novos comerciantes
     * @param formData 
     * @param idModule
     * @returns 
     */
    async ImportMerchantList(formData: FormData, idModule?: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Request/ImportMerchantList?idModule=${idModule || ''}`, formData)); }
        catch (error) { return error; }
    }

    /**
      * Importar lista de consumos dos comerciantes por SAF-T
      * @param formData 
      * @param idModule
      * @returns 
      */
    async ImportMerchantSAFT(formData: FormData): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Request/Invoices/ImportSaftFile`, formData)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param id 
     * @returns 
     */
    async MerchantForcingFirstSync(id): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any[]>(`Merchant/ForcingSync/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantAcceptApplication(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Status/Accepted`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantRejectApplication(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Status/Rejected`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetListMCCs(code: string = null): Promise<IAPIResponse<any[]>> {

        try { return this.handleAuthResponse(await this.RequestGET<any[]>(`Merchant/MCC/List${code ? '?code=' + code : ''}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetListCAEs(): Promise<IAPIResponse<any[]>> {

        try { return this.handleAuthResponse(await this.RequestGET<any[]>(`Merchant/CAE/List`)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @returns 
     */
    async GetCAEsListInUse(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Common/Entity/CAECategory/InUse`)); }
        catch (error) { return error; }
    }

    /**
     * 
     */
    async GetAvailableMerchantList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/AvailableList?PageRows=999&OrderDescending=false`)); }
        catch (error) { return error; }
    }

    /**
     * verifica os dados do representante
     * @param data 
     * @returns 
     */
    async ManagerCheckPersonalData(data: any): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Manager/CheckPersonalData`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @param vatnumber 
     * @returns 
     */
    async GetMerchantVerifyVatNumber(id: string, vatnumber: string): Promise<IAPIResponse<any>> {

        const params = {
            idMerchant: id,
            vatNumber: vatnumber
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Verify/VatNumber`, params)); }
        catch (error) { return error; }
    }
    /**
    * 
    * @param id 
    * @returns 
    */
    async GetMerchantModuleList(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/Module/List/${id}`)); }
        catch (error) { return error; }
    }


    /**
     * 
     * @param id 
     * @returns 
     */
    async GetMerchantModuleCampaignsList(id, idModulesList: string): Promise<IAPIResponse<any>> {

        const params = {
            // "idParentModule": 0,
            idModuleList: idModulesList,
            idMerchant: id,
            // isPublic: true,
            // "isCurrentCampaign": true,
            // "toReturnCampaignFiles": true,
            // "idTypeFile": 0
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Module/List`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @returns 
     */
    async GetAvailableWalletModuleList(): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/AvailableWalletModuleList`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param id 
     * @param data
     * @returns 
     */
    async ConfigureMerchantModule(id, data: number[]): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Module/Configure/${id}`, data)); }
        catch (error) { return error; }
    }


    /**
    * Cancelar o pedido de apelo - altera para o estado [canceled]
    * @param id 
    * @returns 
    */
    async MerchantAppealCancel(id: String): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/Appeal/Cancel/${id}`)); }
        catch (error) { return error; }
    }

    /**
    * Submeter o pedido de apelo - altera para o estado [pendente]
    * @param id 
    * @returns 
    */
    async MerchantAppealSubmit(id: String): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Merchant/Appeal/Submit/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantAppealSave(data: { IdWalletMovement: string, Description: string, AmountNew: any }): Promise<IAPIResponse<any>> {

        const params = {
            IdWalletMovement: data?.IdWalletMovement,
            Description: data?.Description,
            AmountNew: data?.AmountNew
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Appeal/Save`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async MerchantAppealList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            pageNumber: filters?.PageNumber,
            pageRows: filters?.PageRows,
            orderDescending: filters.OrderDescending ?? false,
            // "orderingField": 0,
            // "text": "string",
            // "type": "string",
            // "date": "string",
            // "startDate": "string",
            // "endDate": "string"

        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Appeal/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantTransferList(filters: IFilterList, idPayments: string[] = []): Promise<IAPIPaginationResponse<any>> {

        const params = {
            searchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending ?? false,
                // "orderingField": 0,
                // "text": "string",
                // "type": "string",
                // "date": "string",
                // "startDate": "string",
                // "endDate": "string"

            },
            isToReturnRelatedTransactions: true,
            payment_IdList: idPayments
            //["fc7ade52-a4c3-44c4-bd21-5539bdccd1af" ]
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Transfer/List?idMerchant=${filters?.IdList || ''}`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantTransactionsList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            pageNumber: filters?.PageNumber || null,
            pageRows: filters?.PageRows || null,
            orderDescending: filters.OrderDescending ?? false,
            // "orderingField": 0,
            // "text": "string",
            // "type": "string",
            // "date": "string",
            // "startDate": "string",
            // "endDate": "string"

        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Transaction/List?idMerchant=${filters?.IdList || ''}`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantTransactionsExecutionList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            IdModule: filters?.IdModule || null,
            IdCampaignList: filters?.IdList || [],
            SearchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                // "orderingField": 0,
                // "text": "string",
                // "type": "string",
                // "date": "string",
                // "startDate": "string",
                // "endDate": "string"
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Transaction/Execution/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantTransactionsUserTotalsReport(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            // IdModule: filters?.IdModule || null,
            IdCampaignList: filters?.IdList || [],
            SearchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                // "orderingField": 0,
                // "text": "string",
                // "type": "string",
                // "date": "string",
                // "startDate": "string",
                // "endDate": "string"
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Campaign/User/Totals/Report`, params)); }
        catch (error) { return error; }
    }
    //#endregion

    //#region POINTS OF SALES

    /**
     * 
     * @param text 
     * @param idMerchant 
     * @param idModule 
     * @param voucherCode
     * @returns 
     */
    async SearchConsumerByNumber(text: string = '', idMerchant: string = '', idModule: number = null, voucherCode: string = ''): Promise<IAPIResponse<any>> {

        const params = {
            idMerchant: String(idMerchant || ''),
            idModule: Number(idModule || '') || null,
            cardNumber: String(text || ''),
            voucherCode: String(voucherCode || '')
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`PointOfSales/AvailableModuleList`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param text 
     * @param idMerchant 
     * @param idModule 
     * @param voucherCode
     * @returns 
     */
    async GetAvailableCampaignList(text: string = '', idMerchant: string = '', idModule: number = null, voucherCode: string = ''): Promise<IAPIResponse<any>> {

        const params = {
            idMerchant: String(idMerchant || ''),
            idModule: Number(idModule || '') || null,
            cardNumber: String(text || ''),
            voucherCode: String(voucherCode || '')
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`PointOfSales/AvailableCampaignList`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantRegistConsumption(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`PointOfSales/RegistConsumption`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantConfirmConsumption(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`PointOfSales/ConfirmConsumption`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantUpdateConsumption(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`PointOfSales/UpdateConsumption`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async MerchantSubmitConsumption(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Merchant/Consumption/Submit`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantConsumptionsList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = `includeOCRInfo=${filters?.includeOCRInfo ?? false}&idCampaign=${filters?.IdCampaign || ''}&idStatus=${filters?.IdStatus || ''}&idMerchantList=${filters?.IdList || ''}&idModule=${filters?.IdModule || ''}`;

        const filter =
        {
            pageNumber: filters?.PageNumber,
            pageRows: filters?.PageRows,
            orderDescending: filters.OrderDescending,
            text: filters?.Text,
            // "type": ",
            // "date": "string",
            // "startDate": "string",
            // "endDate": "string"
        }

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`PointOfSales/ConsumptionList?${params}`, filter)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetMerchantConsumption(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`PointOfSales/Consumption/${id}`)); }
        catch (error) { return error; }
    }

    /**
    * 
    * @param id 
    * @returns 
    */
    async GetMerchantConsumptionIntention(id): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`PointOfSales/ConsumptionIntention/${id}`)); }
        catch (error) { return error; }
    }

    //#endregion

    //#region WALLET

    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetMerchantAllConsumptionsList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = `PageNumber=${filters?.PageNumber || ''}
						&PageRows=${filters?.PageRows || ''}
						&OrderDescending=${filters?.OrderDescending ?? true}
						&OrderingField=${filters?.OrderingField || ''}
						&Text=${filters?.Text || ''}
						&StartDate=${filters?.StartDate || ''}
						&EndDate=${filters?.EndDate || ''}
						&idCard=
						&idCampaign=${filters?.IdCampaign || ''}
						&isGenericExpense=
						&idType=${filters?.IdType || ''}
						&idModuleList=${filters.IdModule || ''}
						&idStatusList=${filters.IdStatus || ''}`;

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Movement/List?${params}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @param includeUserWithoutWallet 
     * @returns 
     */
    async GetConsumersWalletResumeList(filters: IFilterList, includeUserWithoutWallet: boolean = true, isSynchronized: boolean = null): Promise<IAPIPaginationResponse<any>> {

        // const queryparams = `includeUserWithoutWallet=${includeUserWithoutWallet}&idModule=${filters?.IdModule || ''}&isSynchronized=${isSynchronized ?? ''}&idCampaign=${filters.IdCampaign || ''}`;

        const params = {
            // "idRole": 0,
            includeUserWithoutWallet: includeUserWithoutWallet ?? true,
            isSynchronized: isSynchronized ?? null,
            idModule: filters?.IdModule || null,
            idCampaignList: filters?.IdList || [],
            searchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                // orderingField: 0,
                text: filters?.Text || '',
                // type: '',
                // date: '',
                // startDate: '',
                // endDate: ''
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/ResumeList`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetUserConsumer(id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Wallet/User/${id}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param formdata 
     * @returns 
     */
    async SaveUserConsumer(formdata: FormData): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Wallet/SaveUserWallet`, formdata)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ConsumerIssueNewCard(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/IssueNewCard`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ConsumersWAlletForcingFirstSync(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/ForcingCreateSyncWalletList`, data)); }
        catch (error) { return error; }
    }

    /**
     * Importar lista de novos comerciantes
     * @param formData 
     * @param idModule 
     * @returns 
     */
    async ImportConsumersList(formData: FormData, idModule): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Request/ImportConsumerList?idModule=${idModule || ''}`, formData)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param formData 
     * @param idModule 
     * @returns 
     */
    async ImportHouseholderList(formData: FormData, idModule): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Request/ImportConsumerHouseholdList?idModule=${idModule || ''}`, formData)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async RequestList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params =
        {
            pageNumber: filters?.PageNumber || null,
            pageRows: filters?.PageRows || null,
            orderDescending: filters.OrderDescending || null,
            text: filters?.Text,
            // "type": filters?.Type,
            // "date": "string",
            // "startDate": "string",
            // "endDate": "string"
        }

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`request/List?idType=${filters?.IdType}`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async ReportGetPointOfSalesReportData(filters: IFilterList, includeFiles: boolean = false): Promise<IAPIPaginationResponse<any>> {

        const params = {
            idType: filters?.IdType || null,
            idTypeList: filters?.IdType || null,
            idStatus: filters?.IdStatus || null,
            idModule: Number(filters?.IdModule) || null,
            idCampaign: filters?.IdCampaign || '',
            idMerchant: filters?.IdList || '',
            startDate: "",
            endDate: "",
            vatNumber: "",
            includeFiles: includeFiles
        }

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Report/GetPointOfSalesReportData`, params)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param filters 
     * @returns 
     */
    async GetConsumersWalletPendingList(filters): Promise<IAPIPaginationResponse<any>> {

        const queryparams = `?IdModule=${filters?.IdModule || ''}&IdStatusModule=${filters?.IdStatus || ''}&PageNumber=${filters?.PageNumber || ''}&PageRows=${filters?.PageRows || ''}&Text=${filters?.Text || ''}&OrderDescending=${filters?.OrderDescending ?? ''}`;

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/ModuleApplicationStatusList${queryparams}`, {})); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param id 
     * @returns 
     */
    async GetConsumersWalletPending(id, idModule?: string, idStatus?: string): Promise<IAPIPaginationResponse<any>> {

        const queryparams = `?IdModule=${idModule || ''}&IdStatus=${idStatus || ''}`;

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Wallet/ModuleApplicationStatus/${id}${queryparams}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param data 
     * @returns 
     */
    async ConsumerChangeBalanceUsageStatus(data): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/ChangeBalanceUsageStatus`, data)); }
        catch (error) { return error; }
    }

    /**
     * @deprecated
     * @param data 
     * @returns 
     */
    async WalletConfigureModule(data: { IdWallet: string, IdModuleList: Number[] }): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Module/Configure`, data)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async WalletCardRequestedList(filters: IFilterList, module: number = null, ageEqualOrGreater: number, hasImage: boolean = true): Promise<IAPIPaginationResponse<any>> {

        const params = {
            pageNumber: filters?.PageNumber,
            pageRows: filters?.PageRows,
            orderDescending: filters.OrderDescending,
            text: filters?.Text,
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Card/RequestedList?idModule=${module || ''}&hasImage=${hasImage || ''}&ageEqualOrGreater=${ageEqualOrGreater || ''}`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @returns 
     */
    async WalletCardRequestList(filters: IFilterList): Promise<IAPIPaginationResponse<any>> {
        const params = {
            SearchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                text: filters?.Text,
            }
        };
        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Card/Request/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param formData 
     * @returns 
     */
    async WalletCardRequestListSave(formData: FormData): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestFilesPOST<any>(`Wallet/Card/Request/Save`, formData)); }
        catch (error) { return error; }
    }

    /**
      * 
      * @param Id 
      * @returns 
      */
    async GetWalletCardRequest(Id: string): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Wallet/Card/Request/${Id}`)); }
        catch (error) { return error; }
    }
    /**
     * 
     * @param idUser 
     * @returns 
     */
    async WalletBalanceUser(idUser): Promise<IAPIResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestGET<any>(`Wallet/Balance/${idUser}`)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param idWallet 
     * @param filters 
     * @returns 
     */
    async WalletMovementList(idWallet, filters: IFilterList): Promise<IAPIPaginationResponse<any>> {

        const params = {
            IdWallet: idWallet,
            IdType: null,
            IdStatus: null,
            IdModule: null,
            SearchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                text: filters?.Text,
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Movement/Simplified/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param filters 
     * @param syncAll 
     * @returns 
     */
    async ConsumersListSyncMygon(filters: IFilterList, syncAll: boolean = false): Promise<IAPIPaginationResponse<any>> {

        const params = {
            idUserList: [],
            IsSynchronized: syncAll,
            idModule: filters?.IdModule || null,
            searchData: {
                pageNumber: filters?.PageNumber,
                pageRows: filters?.PageRows,
                orderDescending: filters.OrderDescending,
                // orderingField: 0,
                text: filters?.Text || '',
                // type: '',
                // date: '',
                // startDate: '',
                // endDate: ''
            }
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Mygon/Sync/List`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @param users 
     * @returns 
     */
    async ConsumersSyncMygon(users: any[] = []): Promise<IAPIPaginationResponse<any>> {

        const params = {
            users: users
        };

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`User/Mygon/Sync`, params)); }
        catch (error) { return error; }
    }

    /**
     * 
     * @returns 
     */
    async GetUnassignedCards(): Promise<IAPIPaginationResponse<any>> {

        try { return this.handleAuthResponse(await this.RequestPOST<any>(`Wallet/Card/Unassigned/List`)); }
        catch (error) { return error; }
    }
    //#endregion

    /**
     * UTILIZAR APENAS EM METODOS SEGUROS
     * @param response 
     * @returns 
     */
    private async handleAuthResponse<T>(response: IAPIResponse<T>) {

        if (!response) return;

        console.log("handler -> ", response.Status);

        if (!response.IsSuccessStatus
            && (response.Status == EnumAPIStatus.InvalidAccessToken
                // 
                // || response.Status == EnumAPIStatus.Unauthorized
            )) {

            this.serverSessionLossSubject.next(true);
        }

        return response;
    }
}
